import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
@Injectable({ providedIn: 'root' })
export class ContactProvider {
  baseUrl: string = environment.API_SERVER;
  constructor(private _http: HttpClient) {}

  getOptions(payload) {
    const params = new HttpParams()
      .set('sidx', 'optionId')
      .set('sord', 'desc')
      .set('rows', '3000')
      .set('page', '1')
      .set('_search', 'true')
      .set('filters', payload.filters);
    return this._http.get(this.baseUrl + '/public/options/', {
      params: params,
    });
  }

  getComplaintTypes(payload) {
    return this._http.get(this.baseUrl + '/public/general_complaint_types/', {
      params: payload.params,
    });
  }

  addComplaintTypes(payload) {
    return this._http.post(
      this.baseUrl +
        '/public/complaint/just_in_time_interpretation/contact_us/',
      payload.body
    );
  }

  getDataStructure(payload) {
    return this._http.get(
      `${this.baseUrl}/public/complaint/just_in_time_interpretation/${payload.complaintTypeId}/`
    );
  }
  sendContactMessage(payload) {
    return this._http.post(this.baseUrl + '/auth/contact_us/', payload.body);
  }

  addContactComplaint(payload) {
    return this._http.post(this.baseUrl + '/public/complaint/', payload.body);
  }

  getTopics(payload) {
    return this._http.get(
      `${this.baseUrl}/chat/topic/all/`);
  }

  getSubtopics(payload) {
    return this._http.get(
      `${this.baseUrl}/chat/${payload.topicId}/subtopic/`);
  }
}
